import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "bg-red-50 text-red-500 rounded-lg p-4 text-sm font-medium" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Внимание, заказ в ОБЕДОМАТ производится на следующий день!")
], -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Тут больше ничего нет ")

import { useRequests } from "@/use/useRequests";

import { computed } from "vue";
import { groupBy } from "lodash";

import { useAsync } from "@/use/useAsync";
import { formatDate } from "@/utils";

import UiSuspense from "@/plugins/ui/components/suspense/UiSuspense.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiCaption from "@/plugins/ui/components/typography/UiCaption.vue";
import RequestCell from "./RequestCell.vue";
import UiCard from "@/plugins/ui/components/card/UiCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestsList',
  setup(__props) {

const { requests, fetchRequests } = useRequests();

const fetchData = useAsync(() => fetchRequests({ limit: "100" }), true);

const grouppedRequests = computed(() => {
  const getWeekday = (date: number) => formatDate(date, { weekday: "long" });
  const getDate = (date: number) =>
    formatDate(date, { day: "2-digit", month: "long" });

  const groupComparator = (date: number) =>
    `${getDate(date)}, ${getWeekday(date)}`;

  const result = groupBy(requests.value, (r) => groupComparator(r.date));

  return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(UiSuspense, _mergeProps(_ctx.$attrs, {
      failure: _unref(fetchData).isFailure.value,
      pending: _unref(fetchData).isPending.value,
      success: _unref(fetchData).isSuccess.value,
      variant: "screen",
      "has-retry": ""
    }), {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(grouppedRequests), (requests, date) => {
          return (_openBlock(), _createBlock(UiGroup, { key: date }, {
            header: _withCtx(() => [
              _createVNode(UiHeader, { title: date }, null, 8, ["title"])
            ]),
            default: _withCtx(() => [
              _createVNode(UiCard, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests, (request) => {
                    return (_openBlock(), _createBlock(RequestCell, {
                      key: request.id,
                      request: request
                    }, null, 8, ["request"]))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _createVNode(UiCaption, {
          level: "3",
          style: {"text-align":"center"}
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16, ["failure", "pending", "success"])
  ], 64))
}
}

})